import type { WorkflowRun, WorkflowRunStatus } from '../../types';

export interface WorkflowGroup {
  workflowName: string;
  runs: WorkflowRun[];
  latestRun: WorkflowRun;
  runCount: number;
  statusCounts: Partial<Record<WorkflowRunStatus, number>>;
  stages: string[];
  gpuTypes: string[];
}

function countStatuses(runs: WorkflowRun[]): Partial<Record<WorkflowRunStatus, number>> {
  const counts: Partial<Record<WorkflowRunStatus, number>> = {};
  for (const run of runs) {
    counts[run.status] = (counts[run.status] ?? 0) + 1;
  }
  return counts;
}

export function groupRunsByWorkflow(runs: WorkflowRun[]): WorkflowGroup[] {
  const groups = new Map<string, WorkflowRun[]>();
  for (const run of runs) {
    const key = run.workflow_name || run.name || 'Ungrouped';
    const list = groups.get(key) ?? [];
    list.push(run);
    groups.set(key, list);
  }

  return Array.from(groups.entries())
    .map(([name, groupRuns]) => {
      const sorted = [...groupRuns].sort(
        (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
      );
      const withOps = sorted.find((r) => (r.ops?.length ?? 0) > 0);
      return {
        workflowName: name,
        runs: sorted,
        latestRun: sorted[0]!,
        runCount: sorted.length,
        statusCounts: countStatuses(sorted),
        stages: (withOps?.ops ?? []).map((op) => op.name),
        gpuTypes: [...new Set(sorted.map((r) => r.gpu_instance_type).filter(Boolean))] as string[],
      };
    })
    .sort(
      (a, b) =>
        new Date(b.latestRun.created_at).getTime() -
        new Date(a.latestRun.created_at).getTime(),
    );
}
